import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

interface MultipleScopeStyledProps {
  bgColor: string;
}

export const MultipleScopeStyled = styled(Box)<MultipleScopeStyledProps>`
  ${({ theme, bgColor }) => css`
    height: ${theme.spacings[300]};
    width: ${theme.spacings[300]};
    background-color: ${bgColor};
  `}
`;
